import AuthPage from "../../components/layout/authPage"
import { ThankU } from "../../components/thankYou"
import { useDictionary } from "../../contexts/dictionary"
import { BoxContainer, MainContainer } from "../../style/base.style"

export const CheckoutThankYou = () => {
    const {translate} = useDictionary()

    return (
        <AuthPage>
        <MainContainer className="main-cont">
          <BoxContainer>
        <ThankU
            title={translate("thank_you")}
            text={translate("success_order")}
            actionText={translate("go_to_dashboard")}
            actionUrl="/dashboard"
        />
        </BoxContainer>
        </MainContainer>
        </AuthPage>
    )

}